import { animate, inView, stagger } from "motion";
import { prefersReducedMotion } from "@/scripts/common/util";
import "./steps.css";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".element-steps").forEach((el) => {
    if (prefersReducedMotion) {
      return;
    }

    const stepsList = el.querySelector(".steps-list");
    const stepItems = el.querySelectorAll(".step-item");
    const sequence = [];

    stepItems.forEach((step) => {
      sequence.push(
        [step.querySelectorAll("[data-sr]"), { opacity: [0, 1], y: [20, 0] }, { duaration: 0.4, delay: stagger(0.2) }],
        [step, { "--border-y": "100%" }, { duration: 0.4, at: "<" }],
        [step, { "--border-x": "100%" }, { duration: 0.4 }],
      );
    });

    inView(
      stepsList,
      () => {
        animate(sequence);
      },
      {
        margin: "0px 0px -15% 0px",
      },
    );
  });
});
